import { render, staticRenderFns } from "./detallePromocion.vue?vue&type=template&id=23552342&scoped=true&"
import script from "./detallePromocion.vue?vue&type=script&lang=js&"
export * from "./detallePromocion.vue?vue&type=script&lang=js&"
import style0 from "./detallePromocion.vue?vue&type=style&index=0&id=23552342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23552342",
  null
  
)

export default component.exports